import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FileSizeFormatter from '../../services/FileSizeFormatter';
import './StorageObjectListItem.scss';

const StorageObjectListItem = (props) => {
  const {
    className,
    object,
    onDelete,
    canDelete,
    canSelect,
    canDownload,
    selected,
    onSelect,
    error,
    repositoryService,
    AvatarComponent,
    ...rest
  } = props;
  const handleDelete = () => {
    onDelete(object);
  };
  const handleSelect = () => {
    if (onSelect) onSelect(object);
  };
  const { storeId, id, name, length, container } = object;
  const size = length ? ` - ${FileSizeFormatter(length)}` : '';
  const style = canSelect ? { cursor: 'pointer' } : {};

  return (
    <ListItem
      classes={{ container: classnames('grb-batchobject-item', className, error && 'grb-error') }}
      onClick={canSelect ? handleSelect : undefined}
      selected={selected}
      style={style}
    >
      {AvatarComponent && (
        <ListItemAvatar>
          <AvatarComponent {...rest} object={object} />
        </ListItemAvatar>
      )}
      <ListItemText primary={`${name}${size}`} secondary={error || container || id || storeId} />
      <ListItemSecondaryAction>
        {canDownload && (
          <a href={repositoryService.getStoreObjectDownloadURL(storeId)} download>
            <Button>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" /></svg>
            </Button>
          </a>
        )}
        {canDelete && (
          <IconButton aria-label="Delete" size="small" onClick={handleDelete}>
            <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path fill="none" d="M0 0h24v24H0z" />
            </svg>
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

StorageObjectListItem.propTypes = {
  object: PropTypes.shape({
    storeId: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    length: PropTypes.number,
    container: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  onDelete: PropTypes.func,
  canDelete: PropTypes.bool,
  canSelect: PropTypes.bool,
  canDownload: PropTypes.bool,
  repositoryService: PropTypes.shape({
    getStoreObjectDownloadURL: PropTypes.func.isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  AvatarComponent: PropTypes.func,
};

StorageObjectListItem.defaultProps = {
  error: undefined,
  className: undefined,
  onDelete: undefined,
  canDelete: false,
  canDownload: false,
  canSelect: true,
  selected: false,
  onSelect: undefined,
  AvatarComponent: undefined,
};

export default StorageObjectListItem;
